<ng-container *vsLet="distributors$ | async as distributors">
  <!-- Skeleton Loader (show while initial data is loading) -->
  <ng-container *ngIf="isInitialLoading">
    <div class="rounded-xl overflow-hidden border border-gray-200 shadow-sm mt-4">
      <vs-table-skeleton
        [rows]="itemsPerPage"
        [columns]="7"
        [columnDefs]="[
          { type: 'text' },
          { align: 'center', type: 'text' },
          { align: 'center', type: 'text' },
          { type: 'badge' },
          { type: 'date' },
          { type: 'date' },
          { type: 'date' },
        ]"
        [showHeader]="true"
        [banding]="true"
      ></vs-table-skeleton>
    </div>
  </ng-container>

  <!-- Content (show after loading completes) -->
  <ng-container *ngIf="!isInitialLoading">
    <ng-container *ngIf="distributorCount; else noDistributors">
      <div class="flex justify-between gap-4 mt-4">
        <div class="flex gap-4">
          <vs-select
            vsInput
            class="w-[200px]"
            [config]="{ placeholder: 'All statuses', allowDeselect: true }"
            [value]="filters?.status ?? null"
            (valueChanges)="onStatusChange($event)"
          >
            <li *ngFor="let status of statuses" vs-select-option [value]="status">
              <vs-badge [theme]="getTheme($any(status))" [config]="{ displayStatusIcon: true }">
                {{ status | titlecase }}
              </vs-badge>
            </li>
          </vs-select>

          <div *ngIf="!distributor" class="flex gap-2">
            <input
              #includeSubDistributors
              id="includeSubDistributors"
              vsInput
              type="checkbox"
              theme="primary"
              class="self-center"
              appearance="toggle"
              tooltipStyle="light"
              style="border-radius: 12px"
              [checked]="!!filters?.includeSubDistributors"
              (input)="refreshTable({ includeSubDistributors: includeSubDistributors.checked })"
            />

            <label for="includeSubDistributors" class="text-sm font-medium text-gray-700 self-center cursor-pointer">
              {{ config.expandAllToggle }}
            </label>
          </div>
        </div>

        <vs-input-container class="max-w-[25%]">
          <vs-icon name="search-lg" slot="start"></vs-icon>
          <input
            #searchInput
            vsInput
            [value]="filters?.search ?? ''"
            (input)="searchInput$.next(searchInput.value)"
            placeholder="Search"
          />
        </vs-input-container>
      </div>

      <div class="rounded-xl overflow-hidden border border-gray-200 shadow-sm mt-4">
        <vs-table
          [columns]="columns"
          [data]="distributors"
          [trackBy]="trackById"
          [rowClasses]="treeRowClasses"
          (rowClicked)="navigateTo($event.id)"
          (sortChanged)="onSortChanged($event)"
        ></vs-table>

        <vs-pagination [config]="paginationConfig$ | async" (pagination)="pagination$.next($event)"></vs-pagination>
      </div>
    </ng-container>

    <ng-template #noDistributors>
      <div class="flex justify-center mt-4" [class]="_distributor ? '' : 'border rounded-2xl p-8 bg-base-white shadow'">
        <vs-empty-state
          [config]="{
            title: _distributor ? 'No sub-distributors found under this distributor.' : 'No distributors found.',
            subtitle:
              'To preview more ' +
              (_distributor ? 'sub-' : '') +
              'distributors you need to invite or add them, so you can manage them and their activities here.',
            imgsrc: 'distributor',
          }"
        >
          <ng-content slot="button" select="[slot='button']"></ng-content>
        </vs-empty-state>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #noDistributors>
    <div class="flex justify-center mt-4" [class]="_distributor ? '' : 'border rounded-2xl p-8 bg-base-white shadow'">
      <vs-empty-state
        [config]="{
          title: _distributor ? 'No sub-distributors found under this distributor.' : 'No distributors found.',
          subtitle:
            'To preview more ' +
            (_distributor ? 'sub-' : '') +
            'distributors you need to invite or add them, so you can manage them and their activities here.',
          imgsrc: 'distributor',
        }"
      >
        <ng-content slot="button" select="[slot='button']"></ng-content>
      </vs-empty-state>
    </div>
  </ng-template>
</ng-container>

<!-- Dialogs -->
<ws-create-distributor-dialog
  #addDistributorDialog
  [distributor]="_distributor"
  [canManageAccountInfo]="(canManageAccountInfo$ | async) ?? false"
  (closed)="navigateTo($event)"
></ws-create-distributor-dialog>
